import { AxiosInstance } from "axios";
import { Event } from "../types/Event";
import { EventImg } from "../types/Event";

export const EventService = {
  getAllEvents: async (api: AxiosInstance): Promise<Event[]> => {
    try {
      const response = await api.get("/event/all");
      return response.data.map((event: any) => ({
        id_event: event.idEvent,
        titre: event.titre,
        description: event.description,
        lieu: event.lieu,
        start_date: event.startDate,
        end_date: event.endDate,
        images: event.images ? event.images.map((img: any) => ({
          id_event_img: img.idEventImg,
          path: img.path,
        })) : [],
      }));
    } catch (error) {
      console.error("Erreur lors de la récupération des événements :", error);
      throw error;
    }
  },

  getEventById: async (api: AxiosInstance, id: number): Promise<Event> => {
    try {
      const response = await api.get(`/event/${id}`);
      const event = response.data;
      return {
        id_event: event.idEvent,
        titre: event.titre,
        description: event.description,
        lieu: event.lieu,
        start_date: event.startDate,
        end_date: event.endDate,
        images: event.images ? event.images.map((img: any) => ({
          id_event_img: img.idEventImg,
          path: img.path,
        })) : [],
      };
    } catch (error) {
      console.error(`Erreur lors de la récupération de l'événement ${id} :`, error);
      throw error;
    }
  },

  createEvent: async (api: AxiosInstance, event: Event): Promise<Event> => {
    try {
      const response = await api.post("/event/add", {
        titre: event.titre,
        description: event.description,
        lieu: event.lieu,
        startDate: event.start_date,
        endDate: event.end_date,
      });
      const e = response.data;
      return {
        id_event: e.idEvent,
        titre: e.titre,
        description: e.description,
        lieu: e.lieu,
        start_date: e.startDate,
        end_date: e.endDate,
        images: [],
      };
    } catch (error) {
      console.error("Erreur lors de la création de l'événement :", error);
      throw error;
    }
  },

  updateEvent: async (api: AxiosInstance, event: Event): Promise<Event> => {
    try {
      const response = await api.put("/event/update", {
        idEvent: event.id_event,
        titre: event.titre,
        description: event.description,
        lieu: event.lieu,
        startDate: event.start_date,
        endDate: event.end_date,
      });
      const e = response.data;
      return {
        id_event: e.idEvent,
        titre: e.titre,
        description: e.description,
        lieu: e.lieu,
        start_date: e.startDate,
        end_date: e.endDate,
        images: [],
      };
    } catch (error) {
      console.error("Erreur lors de la mise à jour de l'événement :", error);
      throw error;
    }
  },

  uploadEventImg: async (api: AxiosInstance, eventId: number, file: File): Promise<EventImg> => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("idEvent", eventId.toString());

    try {
      const response = await api.post("/event-img/upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return {
        id_event_img: response.data.idEventImg,
        path: response.data.path,
        id_event: response.data.idEvent,
      };
    } catch (error) {
      console.error("Erreur lors de l'upload de l'image :", error);
      throw error;
    }
  },

  getAllImgByEvent: async (api: AxiosInstance, eventId: number): Promise<EventImg[]> => {
    try {
      const response = await api.get(`/event-img/by-event/${eventId}`);
      const baseUrl = process.env.REACT_APP_API_URL ?? "http://149.202.58.163:8080/api";

      return response.data.map((img: any) => ({
        id_event_img: img.idEventImg,
        path: `${baseUrl}/event-img/event-img/${encodeURIComponent(img.path)}`,
        id_event: img.idEvent,
      }));
    } catch (error) {
      console.error(`Erreur lors de la récupération des images pour l'événement ${eventId} :`, error);
      throw error;
    }
  },


};
